import { Color, XopsColorRegistry } from "pages/XopsColor/XopsColorRegistry";

function getHumanResourceScheduleLayerStyle(schedule: any) {
    let result = { backgroundColor: "gray", opacity: ".2" };

    if (schedule.finished) {
        result.backgroundColor = XopsColorRegistry.INSTANCE.getColor(Color.SCHEDULE_FINISHED);
    } else if (!schedule.humanResource.vehicle?.id) {
        result.backgroundColor = XopsColorRegistry.INSTANCE.getColor(Color.SCHEDULE_NO_EQUIPMENT);
    } else {
        result.backgroundColor = XopsColorRegistry.INSTANCE.getColor(Color.SCHEDULE_WITH_EQUIPMENT);
    }
    return result;
}

function getBusiestAreaLayerStyle() {
    return { backgroundColor: "red", opacity: ".2" };
}

export const getLayerStyle = (type: string, entity: any): any => {
    switch (type) {
        case "HumanResourceSchedule":
            return getHumanResourceScheduleLayerStyle(entity);
        case "BusiestSlot":
            return getBusiestAreaLayerStyle();
        default:
            return undefined;
    }
}
